// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import UseAmount from './use-amount';
import t from 'tcomb';

const Claim = t.struct({
    claimType: KeyValuePair,
    creditMemo: t.String,
    customerSummary: CustomerSummary,
    dealer: Dealer,
    description: t.String,
    failDate: t.Number,
    failurePart: t.String,
    id: t.String,
    isSubmittingDealer: t.Bool,
    processDate: t.Number,
    referenceNumber1: t.String,
    referenceNumber2: t.String,
    repairDate: t.Number,
    status: t.String,
    subClaimType: KeyValuePair,
    updated: t.Number,
    useAmounts: t.list(UseAmount, 'UseAmounts')
}, {
    name: 'Claim',
    strict: true
});

export const getDefaultState = () => new Claim({
    claimType: getKeyValuePairDefaultState(),
    creditMemo: '',
    customerSummary: getCustomerSummaryDefaultState(),
    dealer: getDealerDefaultState(),
    description: '',
    failDate: 0,
    failurePart: '',
    id: '',
    isSubmittingDealer: true,
    processDate: 0,
    referenceNumber1: '',
    referenceNumber2: '',
    repairDate: 0,
    status: '',
    subClaimType: getKeyValuePairDefaultState(),
    updated: 0,
    useAmounts: []
});

export default Claim;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim.js